export class AreaFuncionalGAFU {
    public descripcion: string;
    public areaFuncional: string;
    public nombreAreaFuncional: string;
    constructor(
        descripcion:string,
        areaFuncional: string,
        nombreAreaFuncional: string
      ) {
        this.descripcion = descripcion;
        this.areaFuncional = areaFuncional;
        this.nombreAreaFuncional = nombreAreaFuncional;
      }
}